import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type IPlanType } from "./types";

const initialState: IPlanType = {
  planType: null,
  planPrice: null,
  discountedPlanPrice: null,
};

const planTypeSlice = createSlice({
  name: "planType",
  initialState,
  reducers: {
    setPlanType: (state, action: PayloadAction<IPlanType>) => {
      state.planType = action.payload.planType;
      state.planPrice = action.payload.planPrice;
      state.discountedPlanPrice = action.payload.discountedPlanPrice;
    },
    resetPlanType: (state) => {
      state.planType = null;
      state.planPrice = null;
      state.discountedPlanPrice = null;
    },
  },
});

// Export actions
export const { setPlanType, resetPlanType } = planTypeSlice.actions;
export default planTypeSlice.reducer;
